<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>官网</el-breadcrumb-item>
      <el-breadcrumb-item>海马运动官网</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <div style="text-align: center">
        <el-button style="margin: 20px" type="primary" @click="addShow = true">添加<i
            class="el-icon-upload el-icon--right"></i></el-button>
        <el-button style="margin: 20px" type="primary" @click="addFootShow = true">添加底部子标签<i
            class="el-icon-upload el-icon--right"></i></el-button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.title">
          <el-table v-if="item.title != '底部列表'" :data="tableData" stripe style="width: 100%">
            <el-table-column prop="title" label="标题" width="180">
            </el-table-column>
            <el-table-column label="图片" width="280">
              <template slot-scope="scope">
                <el-image :src="scope.row.picture_url" style="width: 100px; height: 100px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="content" label="内容" width="1000">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">下架</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else style="display: flex">
            <dl v-for="item in footList" :key="item.id">
              <dt @click="footXiu(item)">{{ item.title }}</dt>
              <dd @click="footXiu(items)" v-for="items in item.entities" :key="items.id">
                {{ items.title }}
              </dd>
            </dl>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 修改 -->
    <el-dialog title="修改" :visible.sync="editShow">
      <el-form ref="form" :model="editForm" :rules="rules" label-width="80px">
        <el-form-item label="标题名称" prop="title">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="editForm.content">
          </el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex">
            <div>
              <el-upload class="upload-demo" drag :action="domain" :data="QiNiYunL" ref="upload" :file-list="fileList"
                :on-success="UploadQiNiu" multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div>
              <el-image :src="editForm.picture_url" style="width: 50%; height: 50%; padding: 20px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">立即修改</el-button>
          <el-button @click="editShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog title="添加" :visible.sync="addShow">
      <el-form ref="form" :model="addForm" :rules="rules" label-width="80px">
        <el-form-item label="标题名称" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择">
            <el-option v-for="item in tabList" :key="item.id" :label="item.title" :value="item.title">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addForm.content">
          </el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex">
            <div>
              <el-upload class="upload-demo" drag ref="upload" :action="domain" :data="QiNiYunL"
                :on-preview="beforeAvatarUpload" :on-success="UploadQiNiu" multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div>
              <el-image :src="addForm.picture_url" style="width: 50%; height: 50%; padding: 20px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddForm('form')">立即添加</el-button>
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改标签" :visible.sync="footShow">
      <el-form ref="form" :model="editForm" :rules="rules" label-width="80px">
        <el-form-item label="链接名称" prop="title">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>

        <el-form-item label="链接">
          <el-input placeholder="请输入链接" v-model="editForm.picture_url">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="suBmitForm('form')">立即修改</el-button>
          <el-button @click="footShow = false">取消</el-button>
          <el-button type="danger" @click="handleDelete(editForm)">下架</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加底部子标签" :visible.sync="addFootShow">
      <el-form ref="form" :model="addForm" :rules="rules" label-width="80px">
        <el-form-item label="链接名称" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="排序级别">
          <el-input placeholder="级别分为1~20" v-model="addForm.weights">
          </el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择">
            <el-option v-for="item in footList" :key="item.id" :label="item.title" :value="item.title">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" prop="content">
          <el-input v-model="addForm.content"> </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitAddForm('form')">立即添加</el-button>
          <el-button @click="addFootShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "guanwang",
  data() {
    return {
      activeName: 0,
      editShow: false,
      addShow: false,

      footShow: false,
      addFootShow: false,
      footList: [],

      fileList: [],
      addForm: {
        title: "",
        content: "",
        picture_url: "",
      },
      editForm: {
        title: "",
        content: "",
        picture_url: "",
      },
      domain: "http://up-z0.qiniup.com", //七牛云
      upGetToken: "https://curiousmore.com/qmore/push/upload/getToken", //gettoken线上接口
      upload_qiniu_addr: "http://img.curiousmore.com/", //显示
      QiNiYunL: {
        key: "",
        token: "",
      },
      tabList: [
        {
          id: 0,
          title: "尊享卡",
        },
        {
          id: 1,
          title: "新闻动态",
        },
        {
          id: 2,
          title: "合作商户",
        },
        {
          id: 3,
          title: "关于我们",
        },
        {
          id: 4,
          title: "尊享卡图片",
        },
        {
          id: 5,
          title: "特权",
        },
        {
          id: 6,
          title: "备案号",
        },
        {
          id: 7,
          title: "背景图",
        },
        {
          id: 8,
          title: "小图标",
        },
      ],
      tableData: [],
      types: "尊享卡",
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
          // { min: 5, message: "长度在 5 个字符以上", trigger: "blur" },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "blur",
          },
        ],
      },
    };
  },

  beforeMount() {
    this.getList();
  },
  mounted: function () {
    this.gettoken(); // 请求token
    this.geFoot();
  },
  methods: {
    beforeAvatarUpload(file) {
      console.log(111);
      this.$refs.upload.clearFiles();
    },
    // 底部列表
    geFoot() {
      this.$fetch(
        "/message/officialWebsiteHaima/queryManagerListPage"
      ).then((res) => {
        this.footList = res.data;
      });
    },
    getList() {
      console.log(this.types, '12345');
      let url =
        "/message/officialWebsiteHaima/queryManagerListPage?status=2&type=" + this.types + '&pageSize=' + 100;
      this.$fetch(url).then((res) => {
        // console.log(789,res);
        this.tableData = res.data.rows;
      });
    },
    handleClick(tab) {
      if (tab.label == "底部列表") {
        this.geFoot();
      } else {
        this.types = tab.label;
        this.getList();
      }
    },
    // 修改窗口
    handleEdit(row) {
      this.editForm.id = row.id;
      this.editForm.title = row.title;
      this.editForm.content = row.content;
      this.editForm.picture_url = row.picture_url;
      this.editShow = true;
    },
    // 底部修改窗口
    footXiu(item) {
      this.editForm.id = item.id;
      this.editForm.title = item.title;
      this.editForm.picture_url = item.picture_url;
      this.footShow = true;
    },
    handleAdd() {
      this.addShow = true;
    },
    // 添加
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let date = this.addForm;
          let url = "/message/officialWebsiteHaima/insert";
          this.$post(url, date).then((res) => {
            if (res.code == 0) {
              // console.log(789,res);
              this.$message({
                message: "恭喜你，添加成功",
                type: "success",
              });
              this.getList();
              this.geFoot();
              this.addShow = false;
              this.addFootShow = false;
              this.addForm = {};
            }
          });
        } else {
          this.$message({
            message: "抱歉，添加失败",
            type: "error",
          });
          return false;
        }
      });
    },
    // 修改
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let date = this.editForm;
          let url = "/message/officialWebsiteHaima/update";
          this.$post(url, date).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "恭喜你，修改成功",
                type: "success",
              });
              this.editShow = false;
              this.footShow = false;
              this.getList();
              this.geFoot();
            }
          });
        } else {
          this.$message({
            message: "抱歉，修改失败",
            type: "error",
          });
          return false;
        }
      });
    },

    suBmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let date = this.editForm;
          let url = "/message/officialWebsiteHaima/update";
          this.$post(url, date).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "恭喜你，修改成功",
                type: "success",
              });
              this.editShow = false;
              this.footShow = false;
              this.getList();
              this.geFoot();
            }
          });
        } else {
          this.$message({
            message: "抱歉，修改失败",
            type: "error",
          });
          return false;
        }
      });
    },

    // 获取token
    gettoken() {
      var timestamp = new Date().getTime();
      let date = {
        key: timestamp.toString(),
        type: "pic",
      };

      const url = this.upGetToken;
      this.$post(url, date).then((res) => {
        this.QiNiYunL.token = res.data;
        this.QiNiYunL.key = date.key;
        console.log(1234, res);
      });
    },
    //图片上传七牛
    UploadQiNiu(file, fileList) {
      let url = this.upload_qiniu_addr + file.key;
      this.gettoken();
      console.log(123, url, fileList);
      // this.$refs.upload.clearFiles()
      if (this.editShow) {
        this.editForm.picture_url = url;
      }
      if (this.addShow) {
        this.addForm.picture_url = url;
      }
      this.$refs.upload.clearFiles();
    },
    // 下架
    handleDelete(row) {
      let date = {
        id: row.id,
        status: 1,
      };
      let url = "/message/officialWebsiteHaima/update";
      this.$post(url, date).then((res) => {
        this.getList();
        this.geFoot();
        this.footShow = false;
      });
    },
  },
};
</script>
<style scoped>
.hidePlus .el-upload--picture-card {
  display: none;
}

dt {
  width: 10rem;
  font-size: 1.25rem;
  text-align: center;
}

dd {
  margin: 0.4375rem;
  color: #a9a9a9;
  font-size: 1.125rem;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/guanwang/guanwang6.vue